// Transform the category data returned from algolia
const transformDesignerCategory = designerData => {
    const { id, image, uri, title } = designerData;

    return {
        id,
        background: image
            ? {
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover',
                  title: image.alt,
                  url: image.url,
              }
            : {},
        heading: title,
        to: uri,
    };
};

export default transformDesignerCategory;
